import Reveal from "@/components/base/Reveal";
import { coverStory, siteMeta } from "@/mocks/home";

export default function HeroCover() {
  return (
    <section id="cover" className="w-full border-b border-background-300 bg-background-50">
      <div className="mx-auto w-full max-w-[1180px] px-4 md:px-6">
        <div className="flex items-center justify-between gap-4 border-b border-background-200 py-3 text-[11px] font-label tracking-[0.18em] text-foreground-500 md:text-xs">
          <span className="whitespace-nowrap">{siteMeta.issue}</span>
          <span className="hidden sm:inline">封面故事 · 逐条对照</span>
          <span className="whitespace-nowrap text-primary-600">{siteMeta.tagline}</span>
        </div>

        <div className="grid grid-cols-1 gap-8 py-8 md:py-12 lg:grid-cols-12 lg:gap-10">
          <Reveal className="lg:col-span-7">
            <div className="flex h-full flex-col">
              <span className="inline-flex w-fit items-center gap-1.5 rounded-md bg-primary-100 px-2.5 py-1 text-[11px] font-medium tracking-wide text-primary-800">
                <i className="ri-file-text-line text-xs" />
                {coverStory.kicker}
              </span>

              <h2 className="mt-4 font-heading text-3xl font-black leading-[1.25] tracking-tight text-foreground-950 md:text-[42px] md:leading-[1.2]">
                {coverStory.title}
              </h2>

              <p className="mt-5 max-w-2xl text-sm leading-[1.9] text-foreground-700 md:text-base">
                {coverStory.standfirst}
              </p>

              <ul className="mt-6 space-y-2.5 border-l-2 border-accent-300 pl-4">
                {coverStory.leads.map((lead) => (
                  <li key={lead} className="flex gap-2 text-xs leading-relaxed text-foreground-700 md:text-sm">
                    <span className="mt-[7px] h-1.5 w-1.5 shrink-0 rounded-full bg-accent-500" />
                    <span>{lead}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-7 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-foreground-500 md:text-sm">
                <span className="font-medium text-foreground-800">{coverStory.byline}</span>
                <span className="h-3 w-px bg-background-400" />
                <span>{coverStory.readTime}</span>
                <span className="h-3 w-px bg-background-400" />
                <span>{coverStory.updated}</span>
              </div>

              <div className="mt-7 flex flex-wrap items-center gap-3">
                <a
                  href="#deep-dive"
                  className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  顺着线索读全文
                  <i className="ri-arrow-right-line text-base" />
                </a>
                <a
                  href="#timeline"
                  className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
                >
                  <i className="ri-node-tree text-base" />
                  先看时间线
                </a>
              </div>

              <dl className="mt-8 grid grid-cols-3 gap-3 border-t border-background-200 pt-5">
                {coverStory.stats.map((stat) => (
                  <div key={stat.label}>
                    <dt className="text-[11px] leading-relaxed text-foreground-500">{stat.label}</dt>
                    <dd className="mt-1 font-heading text-lg font-bold text-foreground-950 md:text-2xl">
                      {stat.value}
                    </dd>
                  </div>
                ))}
              </dl>
            </div>
          </Reveal>

          <Reveal delay={120} className="lg:col-span-5">
            <figure className="flex h-full flex-col">
              <div className="relative w-full overflow-hidden rounded-lg border border-background-300">
                <div className="h-[240px] w-full md:h-[340px] lg:h-[420px]">
                  <img
                    src={coverStory.image}
                    alt="封面故事：长夜未明换角前后的关系网 黑料91深扒 黑料91内幕 线索对照"
                    title="黑料91深扒 封面故事 关系网线索对照"
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <span className="absolute left-4 top-4 rounded-md bg-background-50/92 px-2.5 py-1 text-[11px] font-medium tracking-wide text-primary-700">
                  封面 · 01
                </span>
              </div>
              <figcaption className="mt-3 text-[11px] leading-relaxed text-foreground-500 md:text-xs">
                {coverStory.caption}
              </figcaption>
              <div className="mt-4 hidden rounded-lg border border-secondary-200 bg-secondary-50 p-4 lg:block">
                <p className="text-xs leading-relaxed text-secondary-900">
                  <span className="font-semibold">读法提示：</span>
                  本站只排列可查证的公开记录，不下定论。任一结论，都欢迎用新的线索来替换。
                </p>
              </div>
            </figure>
          </Reveal>
        </div>
      </div>
    </section>
  );
}